/* @flow */
import cx from 'classnames';
import * as React from 'react';
import ReactDOM from 'react-dom';

import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Dialog from 'components/Dialog.jsx';
import Row from 'components/Row.jsx';
import focusNode from 'utils/focusNode';

import type { Props as DialogProps } from 'components/Dialog.jsx'; // eslint-disable-line no-unused-vars

// prettier-ignore
type Props = {
  buttonText?: string,
  closeButtonText?: string,
  /** Primay button action */
  onOkay?: ?Function,
  /* :: ...$Exact<DialogProps>, */
};

export default class AlertDialog extends React.Component<Props> {
  static defaultProps = {
    ...Dialog.defaultProps,
    buttonText: 'OK',
    size: 'xsmall',
  };

  handleButtonClick = () => {
    const { onOkay } = this.props;

    this.requestHide();

    if (onOkay) {
      onOkay();
    }
  };

  requestHide = () => {
    const { onRequestHide } = this.props;
    if (onRequestHide) {
      onRequestHide();
    }
  };

  render() {
    const { buttonText, children, className, closeButtonText } = this.props;

    return (
      <Dialog {...this.props} className={cx('AlertDialog', className)}>
        <BoxBody>
          {children && <Row>{children}</Row>}
          <Buttons axis="y">
            <Button
              ref={component => focusNode(ReactDOM.findDOMNode(component))}
              className="AlertDialog-okButton"
              eventElementName="AlertDialog-okButton"
              onClick={this.handleButtonClick}>
              {buttonText}
            </Button>
            {closeButtonText && (
              <Button level="text" onClick={this.requestHide}>
                {closeButtonText}
              </Button>
            )}
          </Buttons>
        </BoxBody>
      </Dialog>
    );
  }
}
